// Builder-only fabric math (inches). Nothing is held or deducted here; the server re-checks on submit.

export function fabricAvailability(fabricsByStyle) {
  const avail = {};
  Object.values(fabricsByStyle).forEach((list) => (list || []).forEach((f) => { avail[f.fabric_id] = f.available_in; }));
  return avail;
}

export function needOf(piece, styles) {
  const s = styles.find((x) => x.id === piece.style_id);
  const n = Number(s?.fabric_required_in || piece.fabric_required_in || 0);
  return n > 0 ? n : 0;
}

// Allocate selected fabrics in piece order; pieces that no longer fit are "short".
export function allocate(pieces, styles, avail) {
  const used = {};
  const short = new Set();
  pieces.forEach((p) => {
    const f = p.fabric_id;
    if (!f || avail[f] === null || avail[f] === undefined) return;
    const need = needOf(p, styles);
    if (!need) return;
    if ((used[f] || 0) + need > avail[f] + 1e-9) short.add(p.uid);
    else used[f] = (used[f] || 0) + need;
  });
  return { used, short };
}

export function canUse(piece, fabricId, pieces, styles, avail, short) {
  const a = avail[fabricId];
  if (a === null || a === undefined) return true;
  const need = needOf(piece, styles);
  if (!need) return true;
  const others = pieces.reduce((s, q) => (
    q.uid !== piece.uid && q.fabric_id === fabricId && !short.has(q.uid) ? s + needOf(q, styles) : s
  ), 0);
  return others + need <= a + 1e-9;
}
